// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__1lx8x","errorLogs":"EditorFooter_errorLogs__2A7u6"};